
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";

interface LocationFilterProps {
  locationFilter: string;
  onLocationChange: (value: string) => void;
  locations: string[];
}

export function LocationFilter({
  locationFilter,
  onLocationChange,
  locations = [],
}: LocationFilterProps) {
  return (
    <div>
      <Label className="text-foreground">Location</Label>
      <Select value={locationFilter} onValueChange={onLocationChange}>
        <SelectTrigger className="bg-background border-border text-foreground rounded-sm">
          <SelectValue placeholder="Select location" className="text-muted-foreground" />
        </SelectTrigger>
        <SelectContent className="bg-card border-border rounded-sm">
          <SelectItem value="all" className="text-foreground hover:bg-accent">All locations</SelectItem>
          {locations.map((location) => (
            <SelectItem key={location} value={location} className="text-foreground hover:bg-accent">
              {location}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
